// Service data for SEO-rich service pages
// Each service has a slug used in /repair URLs and matches the booking SERVICES id.

export const SERVICE_PAGES = [
  {
    id: "refrigerator",
    slug: "refrigerator-repair",
    name: "Refrigerator",
    title: "Refrigerator Repair in South Jersey | Same-Day Service",
    metaDescription:
      "Expert refrigerator repair in South Jersey. We fix leaks, cooling issues, ice makers and more. Same-day or next-day service guaranteed. Call (609) 451-2225.",
    h1: "Refrigerator Repair in South Jersey",
    intro:
      "A broken refrigerator can spoil hundreds of dollars in groceries in just a few hours. Our certified technicians repair all major refrigerator brands and models, with same-day or next-day service throughout Gloucester, Camden, and Burlington Counties.",
    commonIssues: [
      "Not cooling or freezing properly",
      "Ice maker not working or leaking",
      "Water dispenser not flowing",
      "Loud noises, buzzing, or clicking",
      "Frost build-up in the freezer",
      "Door seal worn or not closing",
      "Compressor or thermostat failure",
      "Lights or control panel not working",
    ],
    brands: [
      "GE",
      "LG",
      "Samsung",
      "Whirlpool",
      "Frigidaire",
      "KitchenAid",
      "Maytag",
      "Bosch",
      "Sub-Zero",
    ],
    why:
      "We diagnose your refrigerator on the spot, provide an upfront quote, and most repairs are completed in a single visit. All parts and labor are backed by our 30-day warranty.",
  },
  {
    id: "washer",
    slug: "washer-repair",
    name: "Washer",
    title: "Washer Repair in South Jersey | Same-Day Washing Machine Service",
    metaDescription:
      "Washing machine repair in South Jersey. We fix leaks, drainage, spin cycle, and noise issues. Same-day or next-day service. Call (609) 451-2225.",
    h1: "Washing Machine Repair in South Jersey",
    intro:
      "Whether your washer won't drain, spin, or fill with water, our experienced technicians get your laundry routine back on track fast. We repair both top-load and front-load washers from every major brand.",
    commonIssues: [
      "Will not start, fill, or drain",
      "Loud noises or vibration during spin",
      "Leaking water on the floor",
      "Won't spin or agitate properly",
      "Door or lid lock failure",
      "Error codes on the display",
      "Clothes coming out too wet",
      "Bad odors or mold buildup",
    ],
    brands: [
      "Whirlpool",
      "Samsung",
      "LG",
      "Maytag",
      "GE",
      "Kenmore",
      "Bosch",
      "Speed Queen",
    ],
    why:
      "We bring the most common washer parts on every truck so most repairs are finished in a single visit. All work is covered by our 30-day parts and labor warranty.",
  },
  {
    id: "dryer",
    slug: "dryer-repair",
    name: "Dryer",
    title: "Dryer Repair in South Jersey | Gas and Electric Dryer Service",
    metaDescription:
      "Fast dryer repair in South Jersey for gas and electric dryers. We fix no-heat, no-spin, and overheating issues. Same-day or next-day service. Call (609) 451-2225.",
    h1: "Dryer Repair in South Jersey",
    intro:
      "Dryers see heavy use and lots can go wrong: heating elements, thermal fuses, drum belts, and vent issues are all common. We service every gas and electric dryer brand and pinpoint the issue on the first visit.",
    commonIssues: [
      "Dryer not heating or runs cold",
      "Drum not spinning",
      "Takes too long to dry clothes",
      "Overheating or shutting off mid-cycle",
      "Loud thumping, squealing, or grinding",
      "Won't start or won't shut off",
      "Burning smell from the vent",
      "Error codes or panel issues",
    ],
    brands: [
      "Whirlpool",
      "LG",
      "Samsung",
      "Maytag",
      "GE",
      "Kenmore",
      "Electrolux",
      "Bosch",
    ],
    why:
      "Clogged vents are a fire hazard. We safely diagnose the root cause, recommend any vent cleaning needed, and complete most repairs the same day.",
  },
  {
    id: "oven",
    slug: "oven-repair",
    name: "Oven and Stove",
    title: "Oven and Stove Repair in South Jersey | Same-Day Service",
    metaDescription:
      "Oven, stove, and range repair in South Jersey. Gas and electric. Same-day or next-day service. Licensed and insured. Call (609) 451-2225.",
    h1: "Oven, Stove, and Range Repair in South Jersey",
    intro:
      "From wall ovens and ranges to cooktops, our technicians safely diagnose and repair gas and electric units. We carry common bake elements, igniters, thermostats, and control boards on every truck.",
    commonIssues: [
      "Oven not heating or wrong temperature",
      "Burners not igniting (gas) or heating (electric)",
      "Broiler not working",
      "Self-clean cycle failure",
      "Door won't close or seal",
      "Control panel or display errors",
      "Convection fan not running",
      "Gas smell or igniter clicking",
    ],
    brands: [
      "GE",
      "Whirlpool",
      "Samsung",
      "LG",
      "Maytag",
      "Frigidaire",
      "KitchenAid",
      "Bosch",
      "Viking",
      "Wolf",
    ],
    why:
      "We follow strict safety procedures for gas appliances and verify proper operation before we leave. Every job is backed by our 30-day warranty.",
  },
  {
    id: "dishwasher",
    slug: "dishwasher-repair",
    name: "Dishwasher",
    title: "Dishwasher Repair in South Jersey | Leaks, Drainage and More",
    metaDescription:
      "Dishwasher repair in South Jersey. We fix leaks, draining, soap dispenser, and cleaning issues. Same-day or next-day service. Call (609) 451-2225.",
    h1: "Dishwasher Repair in South Jersey",
    intro:
      "If your dishwasher leaves dishes dirty, won't drain, or leaks under the sink, we'll find the cause and fix it fast. We service all built-in and portable dishwashers from every major brand.",
    commonIssues: [
      "Not cleaning dishes properly",
      "Won't drain or standing water",
      "Leaking under or around the unit",
      "Door latch or gasket issues",
      "Soap dispenser stuck",
      "Loud noises during cycle",
      "Error codes or won't start",
      "Detergent left in dispenser",
    ],
    brands: [
      "Bosch",
      "KitchenAid",
      "Whirlpool",
      "GE",
      "LG",
      "Samsung",
      "Frigidaire",
      "Maytag",
    ],
    why:
      "Most dishwasher problems come down to clogged spray arms, drain hoses, or a faulty pump — issues we usually resolve in one visit.",
  },
  {
    id: "garbage-disposal",
    slug: "garbage-disposal-repair",
    name: "Garbage Disposal",
    title: "Garbage Disposal Repair in South Jersey | Same-Day Service",
    metaDescription:
      "Garbage disposal repair and replacement in South Jersey. Clogs, leaks, jams, and humming units. Same-day service. Call (609) 451-2225.",
    h1: "Garbage Disposal Repair in South Jersey",
    intro:
      "A jammed or leaking garbage disposal can quickly turn into a kitchen disaster. We repair and replace garbage disposals from every major brand, with most jobs completed the same day.",
    commonIssues: [
      "Disposal won't turn on",
      "Humming but not spinning",
      "Leaking from underneath",
      "Clogged or draining slowly",
      "Loud grinding or rattling",
      "Resetting repeatedly (tripping breaker)",
      "Bad odor from the drain",
      "Old unit needs replacement",
    ],
    brands: ["InSinkErator", "Waste King", "Moen", "GE", "KitchenAid", "Whirlpool"],
    why:
      "We can repair most disposals on the spot or install a new unit the same day if replacement is the better value.",
  },
];

export const getServiceBySlug = (slug) =>
  SERVICE_PAGES.find((s) => s.slug === slug);
